import { versionHighlights } from '@/mocks/appData';

export default function VersionSection() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          <div>
            <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
              <i className="ri-sparkling-line"></i>
              最新版本
            </div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-4">
              v3.8.2 版本亮点
            </h2>
            <ul className="space-y-4">
              {versionHighlights.map((item) => (
                <li key={item.id} className="flex items-start gap-3">
                  <div className="w-6 h-6 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mt-0.5 flex-shrink-0">
                    <i className="ri-check-line text-sm"></i>
                  </div>
                  <span className="text-sm text-foreground-700 leading-relaxed">{item.text}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20smartphone%20mockup%20displaying%20clean%20app%20interface%20with%20warm%20orange%20accents%2C%20floating%20on%20minimal%20cream%20background%2C%20soft%20shadows%2C%20elegant%20product%20photography%20style%2C%20clean%20composition&width=800&height=600&seq=version-showcase&orientation=landscape"
                alt="CPP v3.8.2 版本展示"
                className="w-full h-auto rounded-2xl"
              />
            </div>
            <div className="absolute -bottom-4 -right-4 w-24 h-24 flex items-center justify-center rounded-2xl bg-primary-500 text-background-50">
              <div className="text-center">
                <div className="text-2xl font-bold">3.8</div>
                <div className="text-xs opacity-80">最新版</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}